export const baseStyle = {
  button: { color: 'white', borderRadius: 20, paddingInline: 45 },
  row: { marginTop: 30 }
};
export const colors = {
  anytimeBlue: '#175FFF',
  disabledGrey: '#E0E0E0'
};
export const row = { marginTop: 30 };
